import qs from "query-string";
import { http } from "../client";
import { mapUserObjectToUser } from "../shared/user";
import { getUser } from "./get-one";
var URL = "users";
var getMany = function (_a) {
    var take = _a.take, role = _a.role, username = _a.username, russianLegalEntityTitle = _a.russianLegalEntityTitle, skip = _a.skip;
    return http.api
        .get(URL, {
        params: {
            take: take,
            skip: skip,
            role: role,
            username: username,
            russian_legal_entity_title: russianLegalEntityTitle,
        },
        paramsSerializer: function (params) {
            return qs.stringify(params, { arrayFormat: "comma", skipEmptyString: true });
        },
    })
        .then(function (_a) {
        var _b = _a.data.data, total = _b.total, skip = _b.skip, take = _b.take, items = _b.items;
        return ({
            total: total,
            skip: skip,
            take: take,
            items: items.map(mapUserObjectToUser),
        });
    });
};
var update = function (_a) {
    var id = _a.id, name = _a.name, email = _a.email, password = _a.password, passwordResetAt = _a.passwordResetAt;
    return http.api
        .put(URL + "/" + id, {
        name: name,
        email: email,
        password: password,
        password_reset_at: passwordResetAt,
    })
        .then(function (res) { return res.data.data; })
        .then(function (res) { return mapUserObjectToUser(res); });
};
var create = function (request) { return http.api.post(URL, request); };
export var usersApi = {
    getMany: getMany,
    getOne: getUser,
    update: update,
    create: create,
};
